import React, { useEffect, useState } from "react";
import { CollaboratorsAPI } from "@/lib/api";
import { useAuth } from "@/lib/providers";

export default function Collaborators({ projectId, ownerId }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const isOwner = user?.user_id === ownerId || user?.role === "admin";

  const load = async () => {
    try {
      const { data } = await CollaboratorsAPI.list(projectId);
      setItems(data || []);
    } catch (e) {
      setErr(e?.response?.data?.detail || e.message);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId]);

  const add = async () => {
    if (!email.trim()) return;
    setBusy(true); setErr("");
    try {
      await CollaboratorsAPI.add(projectId, email.trim());
      setEmail("");
      await load();
    } catch (e) {
      setErr(e?.response?.data?.detail || e.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async (uid) => {
    if (!window.confirm("Remove this collaborator?")) return;
    await CollaboratorsAPI.remove(projectId, uid);
    setItems((xs) => xs.filter((x) => x.user_id !== uid));
  };

  return (
    <div className="v-surface" style={{ padding: 20 }} data-testid="collaborators-panel">
      <div className="overline">Collaborators · {items.length}</div>
      <p style={{ marginTop: 6, fontSize: 13, color: "var(--v-text-2)", lineHeight: 1.5 }}>
        Anyone you add can view this project's brief, library and assessments, and post comments.
      </p>

      {isOwner && (
        <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
          <input
            className="v-input"
            placeholder="designer@studio.com"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="collab-email-input"
            style={{ flex: 1 }}
          />
          <button className="v-btn" onClick={add} disabled={busy || !email.trim()} data-testid="collab-add-btn">
            {busy ? "Adding…" : "Invite"}
          </button>
        </div>
      )}
      {err && <div className="mono" style={{ marginTop: 8, fontSize: 11, color: "var(--v-accent)" }}>{err}</div>}

      <div style={{ marginTop: 14, display: "grid", gap: 8 }}>
        {items.map((c) => (
          <div key={c.user_id} className="v-surface-flat" data-testid={`collab-${c.user_id}`} style={{ padding: 10, border: "1px solid var(--v-border)", borderRadius: "var(--radius)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 13 }}>{c.name || c.email}</div>
              <div className="mono" style={{ fontSize: 10, color: "var(--v-text-2)" }}>{c.email} · invited by {c.invited_by_name}</div>
            </div>
            {(isOwner || user?.user_id === c.user_id) && (
              <button
                className="v-btn v-btn-ghost"
                onClick={() => remove(c.user_id)}
                data-testid={`collab-remove-${c.user_id}`}
                style={{ padding: "6px 10px", fontSize: 10 }}
              >
                {user?.user_id === c.user_id ? "Leave" : "Remove"}
              </button>
            )}
          </div>
        ))}
        {items.length === 0 && (
          <div className="mono" style={{ fontSize: 11, color: "var(--v-text-3)" }}>No collaborators yet.</div>
        )}
      </div>
    </div>
  );
}
